"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.profession.list': 'Zawody',
    'route.profession.create': 'Dodaj zawód',
    'route.profession.edit': 'Edytuj zawód',
};
